export const StorageProps = {
  currentUser: "user",
  portalAccessToken: "portal_access_token",
  buildNumber: "build_number",
  firstLoadCompleted: "first_load_completed",
  mobileView: "mobile_view",
};
